module.exports = require('./src/skeletal-animation-system')
